var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.684 6.97021C15.0081 6.97021 16.2779 7.49621 17.2142 8.4325C18.1505 9.36878 18.6765 10.6387 18.6765 11.9628V17.7874H15.3481V11.9628C15.3481 11.5214 15.1728 11.0981 14.8607 10.786C14.5486 10.4739 14.1253 10.2986 13.684 10.2986C13.2426 10.2986 12.8193 10.4739 12.5072 10.786C12.1951 11.0981 12.0198 11.5214 12.0198 11.9628V17.7874H8.69141V11.9628C8.69141 10.6387 9.21741 9.36878 10.1537 8.4325C11.09 7.49621 12.3599 6.97021 13.684 6.97021Z",
    stroke: "#3B7DDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36303 7.80225H2.03467V17.7873H5.36303V7.80225Z",
    stroke: "#3B7DDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69885 5.30591C4.61795 5.30591 5.36303 4.56083 5.36303 3.64172C5.36303 2.72262 4.61795 1.97754 3.69885 1.97754C2.77975 1.97754 2.03467 2.72262 2.03467 3.64172C2.03467 4.56083 2.77975 5.30591 3.69885 5.30591Z",
    stroke: "#3B7DDD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9702,
    height: 19.9702,
    fill: "white",
    transform: "translate(0.370605 0.313477)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ebfaedb4c6370fa5cd5e3fb0707bbe22.svg";
export { ForwardRef as ReactComponent };